














import { Component, Prop, Vue } from 'vue-property-decorator';
import StarIcon from '../../icons/StarIcon.vue';

@Component({
  components: {
    StarIcon
  }
})
export default class Rating extends Vue {
  @Prop(Boolean) disabled!: boolean;
  @Prop(Number) value!: number;
  @Prop(Boolean) hasError!: boolean;

  setValue(value: number) {
    if (!this.disabled) {
      this.$emit('change', value);
    }
  }
}
